import {AbstractModel} from '../abstract-model';
import {Goal} from '../goal';
import {Offer} from '../offer';

export class Postback extends AbstractModel {
  id: number | null = null;
  name: string = '';
  partnerId: number | null = null;
  subId: string = '';
  goal: Goal | null = null;
  goalId: number | null = null;
  url: string = '';
  includePrivate: boolean = true;
  enabled: boolean = true;
  count: number = 0;
  offers: Offer[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.goal) {
      this.goal = new Goal().deserialize(input.goal);
    }

    if (input.offers) {
      this.offers = input.offers.map((offer: any) => new Offer().deserialize(offer));
    }

    return this;
  }

  override toString(): string {
    return this.name;
  }
}
